var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29ACD6",
    fillOpacity: 0.35,
    d: "M27.04 9.917a9.167 9.167 0 0 0-12.405 0c-.144.132-.297.285-.496.484l-2.992 2.992a12.45 12.45 0 0 0-3.35 11.506A62.21 62.21 0 0 0 55.03 72.134c4.156.923 8.496-.34 11.506-3.351l2.992-2.991c.199-.2.352-.353.484-.497a9.167 9.167 0 0 0 0-12.404c-.132-.144-.285-.297-.484-.496l-4.898-4.898a11.7 11.7 0 0 0-12.943-2.451 6.7 6.7 0 0 1-7.41-1.404l-7.99-7.989a6.7 6.7 0 0 1-1.403-7.41 11.7 11.7 0 0 0-2.452-12.944l-4.898-4.898c-.199-.199-.352-.352-.496-.484"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#call_svg__b)",
    strokeLinecap: "round",
    d: "M27.378 9.549a9.667 9.667 0 0 0-13.081 0c-.152.139-.312.299-.506.493l-.006.006h0l-2.991 2.991a12.95 12.95 0 0 0-3.485 11.969 62.71 62.71 0 0 0 47.614 47.614c4.323.96 8.837-.354 11.968-3.486l2.991-2.99h0l.005-.006c.195-.195.355-.355.495-.506a9.667 9.667 0 0 0 0-13.081c-.14-.152-.3-.312-.494-.506l-.006-.006h0l-4.897-4.898a12.2 12.2 0 0 0-13.497-2.556 6.2 6.2 0 0 1-6.857-1.298l-7.99-7.99a6.2 6.2 0 0 1-1.298-6.856 12.2 12.2 0 0 0-2.556-13.497l-4.898-4.898h0l-.006-.006c-.194-.194-.354-.354-.505-.493Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "call_svg__b",
    x1: 7.5,
    x2: 72.463,
    y1: 7.5,
    y2: 72.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "call_svg__a",
    width: 114.931,
    height: 114.93,
    x: -17.5,
    y: -17.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_3167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_3167",
    result: "shape"
  })))));
};
export { SvgCall as ReactComponent };